























































































































































import {Component} from 'vue-property-decorator'
import {Getter} from "vuex-class";
import {Tabs, ScrollButton} from 'wings-ui-components';
import ActionUsersFilter from "@/components/UserManagement/ActionUsers/ActionUsersFilter.vue";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import {ActionUserItem} from "@/store/user_management/action_users/types";
import {dateFilter} from "@/utils/date-util";

@Component({
  components: {ActionUsersFilter, Tabs, ScrollButton},
  filters: {dateFilter},
})
export default class ActionUsers extends BaseItemsPage<ActionUserItem> {
  is_show_filter = true;
  private localLang: string = this.$i18n.locale;
  currentSort = "action_date";
  currentSortOrder = "desc";
  tableFields = [
    'action_date',
    'action_user',
    'action_page',
    'action_source',
    'object_type',
    'action',
    'action_status',
    'ip_address',
    'additional_info'
  ];

  @Getter("actionUsers") actionUsersResponse: any;
  @Getter("isLoadingDetailStat") isLoadingDetailStat!: boolean;
  @Getter("objectTypes") objectTypesList: any;
  @Getter("systemUsersAction") systemUsersActionList: any;
  @Getter("systemPages") systemPagesList: any;
  @Getter("partnerUsersPages") partnerPagesList: any;

  created() {
    this.localLang = this.$i18n.locale;
  }

  get objectType() {
    return new Map(this.objectTypesList.map((object: any) => {
        return [object.eng_name, object.rus_name]}))
  }

  get systemUserAction() {
    return new Map(this.systemUsersActionList.map((object: any) => {
        return [object.eng_name, object.rus_name]}))
  }

  get actionPage() {
    return new Map([...this.systemPagesList, ...this.partnerPagesList].map((object: any) => {
        if (this.localLang === 'ru') return [object.name, object.rus_name]
        else return [object.name, object.eng_name]}))
  }

  getData(): any {
    return this.actionUsersResponse;
  }

  getActionPageLabel(value: string) {
    return this.actionPage.get(value);
  }

  getObjectTypeLabel(value: string) {
    return this.localLang === 'ru' ? this.objectType.get(value) : value;
  }

  getSystemUserActionLabel(value: string) {
    return this.localLang === 'ru' ? this.systemUserAction.get(value) : value;
  }
}
